module.exports = __webpack_public_path__ + "static/kirsty-cover-87278ac5228666907e73b53b0648e6ef.png";